export const formatDateWithTimezone = (
    date: string,
    timezone: string
): string =>
    new Date(date).toLocaleDateString('en-US', {
        timeZone: timezone,
    });
